import { useState } from "react";
export const PAGE_SIZE = 24;
export const DAY_OPTIONS = [
    { label: "Últimas 24 horas", value: 1 },
    { label: "Últimos 7 dias", value: 7 },
    { label: "Últimos 15 dias", value: 15 },
    { label: "Últimos 30 dias", value: 30 },
    { label: "Últimos 60 dias", value: 60 },
];
export const useAlertFilters = () => {
    const [page, setPage] = useState(0);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedDays, setSelectedDays] = useState();
    const [draftCategories, setDraftCategories] = useState([]);
    const [draftDays, setDraftDays] = useState();
    const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);
    const handlePageChange = (newPage) => {
        setPage(newPage - 1);
    };
    const openFilter = () => {
        setDraftCategories(selectedCategories);
        setDraftDays(selectedDays);
        setIsFilterDialogOpen(true);
    };
    const cancelFilter = () => {
        setDraftCategories(selectedCategories);
        setDraftDays(selectedDays);
        setIsFilterDialogOpen(false);
    };
    const applyFilter = () => {
        setPage(0);
        setSelectedCategories(draftCategories);
        setSelectedDays(draftDays);
        setIsFilterDialogOpen(false);
    };
    const clearFilter = () => {
        setSelectedCategories([]);
        setSelectedDays(undefined);
        setPage(0);
    };
    return {
        page,
        selectedCategories,
        selectedDays,
        draftCategories,
        setDraftCategories,
        draftDays,
        setDraftDays,
        isFilterDialogOpen,
        setIsFilterDialogOpen,
        handlePageChange,
        openFilter,
        cancelFilter,
        applyFilter,
        clearFilter,
    };
};
